enum IncomeShareConstants {
  GET_INCOME_SHARE_REQUEST = "GET_INCOME_SHARE_REQUEST",
  GET_INCOME_SHARE_SUCCESS = "GET_INCOME_SHARE_SUCCESS",
  GET_INCOME_SHARE_FAILURE = "GET_INCOME_SHARE_FAILURE",

  ADD_INCOME_SHARE_REQ = "ADD_INCOME_SHARE_REQ",
  ADD_INCOME_SHARE_SUCCESS = "ADD_INCOME_SHARE_SUCCESS",
  ADD_INCOME_SHARE_FAILURE = "ADD_INCOME_SHARE_FAILURE",

  EDIT_INCOME_SHARE_REQUEST = "EDIT_INCOME_SHARE_REQUEST",
  EDIT_INCOME_SHARE_SUCCESS = "EDIT_INCOME_SHARE_SUCCESS",
  EDIT_INCOME_SHARE_FAILURE = "EDIT_INCOME_SHARE_FAILURE",

  SPECIFIC_INCOME_SHARE_REQUEST = "SPECIFIC_INCOME_SHARE_REQUEST",
  SPECIFIC_INCOME_SHARE_SUCCESS = "SPECIFIC_INCOME_SHARE_SUCCESS",
  SPECIFIC_INCOME_SHARE_FAILURE = "SPECIFIC_INCOME_SHARE_FAILURE",

  GET_SPECIFIC_INCOME_REQUEST = "GET_SPECIFIC_INCOME_REQUEST",
  GET_SPECIFIC_INCOME_SUCCESS = "GET_SPECIFIC_INCOME_SUCCESS",
  GET_SPECIFIC_INCOME_FAILURE = "GET_SPECIFIC_INCOME_FAILURE",

  RESET_INCOME_SHARE_REQUEST = "RESET_INCOME_SHARE_REQUEST",
}

export default IncomeShareConstants;
